import { RequestType } from '@i9portal/shared';
import type { RequestSlug } from '../types/requests';

export const REQUEST_SLUG: Record<RequestType, RequestSlug> = {
  OVERTIME: 'horas-extras',
  REIMBURSEMENT: 'reembolsos',
};

export function slugToRequestType(slug: string | undefined): RequestType | null {
  if (slug === 'horas-extras') return RequestType.OVERTIME;
  if (slug === 'reembolsos') return RequestType.REIMBURSEMENT;
  return null;
}

/** Rota de detalhe do funcionário. */
export function employeeRequestPath(type: RequestType, id: string): string {
  return `/${REQUEST_SLUG[type]}/${id}`;
}

/** Rota de detalhe do RH. */
export function hrRequestPath(type: RequestType, id: string): string {
  return `/rh/solicitacoes/${REQUEST_SLUG[type]}/${id}`;
}
